import * as React from 'react'
import { createPortal } from 'react-dom'

export class PortalContentNavigationPublic extends React.PureComponent<{ children?: React.ReactNode }> {
    public render() {
        const element = document.querySelector('[data-contentnavigation-public]')

        if (!element) {
            return this.props.children
        }

        return createPortal(this.props.children, element)
    }
}
